import { GET_LEAD_QUALITY } from "../../Actions/ActionConstants";

function leadQualityReducer(state = null, action) {
    switch (action.type) {
        case GET_LEAD_QUALITY:
            if (action.data) { return action.data; }
            else { return state }
        default:
            return state;
    }
}
export default leadQualityReducer